import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { useEffect } from 'react'

import { fetchOfferBasedRecommendations } from 'actions/RecommendationActions'
import Heading from 'LuxKit/Typography/Heading'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { getGraphRecommendations } from 'selectors/recomendations/graphSelectors'
import styled from 'styled-components'
import ExpiredDealsHeroOffers from './ExpiredDealsHeroOffers'
import useIdleTimeReporter, { IdleTimeSource } from '../hooks/useIdleTimeReporter'
import ExpiredDealsOfferPill from './ExpiredDealsOfferPill'
import { take } from 'lib/array/arrayUtils'
import { useIntl } from 'react-intl'

const Background = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  padding-top: ${rem(20)};
`

const RootLayout = styled.div`
background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

interface Props {
  offer: App.Offer
}

function ExpiredDealsHero(props: Props) {
  const { offer } = props
  const intl = useIntl()
  const dispatch = useAppDispatch()

  useIdleTimeReporter(IdleTimeSource.ExpiredDeals)

  useEffect(() => {
    dispatch(fetchOfferBasedRecommendations(offer.id, false))
  }, [dispatch, offer.id])

  const offersSimilarToTopOffer = useAppSelector<App.OfferBasedGraphRecommendation>(state => getGraphRecommendations(state, offer.id))
  const similarOffersLoading = offersSimilarToTopOffer.state === 'loading'
  const title = offer.property
    ? intl.formatMessage(
        {
          id: 'qL4imqDsclHBgIJZnxnu',
          defaultMessage: 'Offers similar to {hotelName}',
        },
        { hotelName: offer.property.name },
      )
    : intl.formatMessage({
        id: '7gkTQhSnXGeywkXDLDq1',
        defaultMessage: 'Similar offers',
      })
  const offerIds = take(offersSimilarToTopOffer.offerIds, 6)
  return (
    <Background>
      <RootLayout>
        <ExpiredDealsOfferPill offer={offer} />
        <ExpiredDealsHeroOffers
          heading={<Heading variant="heading5">{title}</Heading>}
          offerIds={offerIds}
          fetching={similarOffersLoading}
          trackingPageSource={offer.type}
          trackingUiTouchPoint="Expired Deals Header V2.0.1"
        />
      </RootLayout>
    </Background>
  )
}

export default withOfferPageAndReduxState((state) => {
  return {
    offer: state.offer,
  }
}, ExpiredDealsHero)
